import { render, staticRenderFns } from "./weightSetting.vue?vue&type=template&id=1f4c2c98&scoped=true"
import script from "./weightSetting.vue?vue&type=script&lang=js"
export * from "./weightSetting.vue?vue&type=script&lang=js"
import style0 from "./weightSetting.vue?vue&type=style&index=0&id=1f4c2c98&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4c2c98",
  null
  
)

export default component.exports